"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const CatalogItemsPage_1 = __importDefault(require("./CatalogItemsPage"));
const CatalogsExportPage_1 = __importDefault(require("./CatalogsExportPage"));
const CatalogsExportSummaryPage_1 = __importDefault(require("./CatalogsExportSummaryPage"));
const CatalogsIndex = ({ match }) => {
    const { path } = match;
    return (react_1.default.createElement("div", { className: 'w-full flex flex-col h-full page' },
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/export`, component: CatalogsExportPage_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/export/summary`, component: CatalogsExportSummaryPage_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: `${path}/`, component: CatalogItemsPage_1.default }))));
};
exports.default = CatalogsIndex;
